// Предупреждение при уходе с формы с несохранёнными изменениями. <Prompt> роутера спрашивает
// через getUserConfirmation: по умолчанию это окно браузера, здесь вместо него своё окно
// (LeaveDialog). Роутер ждёт ответа через callback(true | false).
let listener = null;

// Окно подписывается, пока оно на экране.
export const onLeaveRequest = (next) => {
  listener = next;
  return () => {
    if (listener === next) listener = null;
  };
};

// Передаётся роутеру как getUserConfirmation. Если окна на экране нет, спрашиваем окном
// браузера: уйти без вопроса нельзя.
export const askToLeave = (message, callback) => {
  if (listener) {
    listener({ message, callback });
    return;
  }
  callback(window.confirm(message));
};

// После «Сохранить» форма закрывается сама, и спрашивать об этом уходе не нужно: один раз
// пропускаем проверку.
let skipNext = false;
export const skipNextLeaveCheck = () => {
  skipNext = true;
};
export const resetLeaveCheck = () => {
  skipNext = false;
};

// message для <Prompt>: функция роутера. true значит «уходить можно», строка — спросить.
export const leaveCheck = (message) => () => {
  if (skipNext) {
    skipNext = false;
    return true;
  }
  return message;
};
